import script from "./RoomList.vue?vue&type=script&setup=true&lang=js"
export * from "./RoomList.vue?vue&type=script&setup=true&lang=js"

import "./RoomList.vue?vue&type=style&index=0&id=ba4566dc&scoped=true&lang=css"

import exportComponent from "/www/wwwroot/pet/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ba4566dc"]])

export default __exports__